import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
// reactstrap components
import { Table } from "reactstrap";
import axios from "axios";
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import { MDBDataTableV5 } from "mdbreact";
import { BASE_URL } from "utils/constants";
import Swal from "sweetalert2";

// Printing the rendered receipt only
const PrintElem = async (id) => {
  var mywindow = window.open("", "PRINT", "height=700,width=800");
  var content = document.querySelector(`#${id}`)?.innerHTML;
  mywindow.document.write(`<!doctype html>
    <html lang="en">
      <head>
        <!-- Required meta tags -->
        <meta charset="utf-8">
        <meta name="viewport" content="width=device-width, initial-scale=1">

        <!-- Bootstrap CSS -->
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-1BmE4kWBq78iYhFldvKuhfTAU6auU8tT94WrHftjDbrCEXSU1oBoqyl2QvZ6jIW3" crossorigin="anonymous">

        <title>Print Schedule</title>
      </head>
      <body>`);
  mywindow.document.write(content);
  mywindow.document
    .write(`<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js" integrity="sha384-ka7Sk0Gln4gmtz2MlQnikT1wXgYsOg+OMhuP+IlRH9sENBO0LRn5q+8nbTov4+1p" crossorigin="anonymous"></script>
    </body>
</html>`);

  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10*/
  mywindow.onafterprint = () => {
    
    //mywindow.close();
  };
  mywindow.print();

  return true;
};

const Schedual = () => {
  const permissions = useSelector((state) => state.permissions);
  const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"];
  const [scheduleSun, setScheduleSun] = useState([]);
  const [scheduleMon, setScheduleMon] = useState([]);
  const [scheduleTue, setScheduleTue] = useState([]);
  const [scheduleWed, setScheduleWed] = useState([]);
  const [scheduleThu, setScheduleThu] = useState([]);

  useEffect(async () => {
    Swal.showLoading();
    try {
      
      let res = await axios.post(`${BASE_URL}/student/getschedule.php`, {
        sId: permissions.id,
      });
      
      setScheduleSun(
        res.data.data.sun.sort((a, b) =>
          Number(a.lecture) > Number(b.lecture) ? 1 : -1
        )
      );
      setScheduleMon(
        res.data.data.mon.sort((a, b) =>
          Number(a.lecture) > Number(b.lecture) ? 1 : -1
        )
      );
      setScheduleTue(
        res.data.data.tue.sort((a, b) =>
          Number(a.lecture) > Number(b.lecture) ? 1 : -1
        )
      );
      setScheduleWed(
        res.data.data.wed.sort((a, b) =>
          Number(a.lecture) > Number(b.lecture) ? 1 : -1
        )
      );
      setScheduleThu(
        res.data.data.thu.sort((a, b) =>
          Number(a.lecture) > Number(b.lecture) ? 1 : -1
        )
      );
    } catch {
      Swal.fire("Something Went Wrong", "", "error");
    } finally {
      Swal.close();
    }
  }, []);

  return (
    <>
      <PanelHeader size="sm" />
      <div className="content mt-4">
        <h4 className="mt-4">Schedule</h4>
        <button
          className="btn btn-primary fs-6 fw-bold"
          onClick={() => {
            PrintElem("cont");
          }}
        >
          Print
        </button>
        <div id="cont" className="w-100 justify-content-center">
          <table className="table table-bordered table-striped">
            <thead>
              <th>Day</th>
              <th>Lecture (Time)</th>
              <th>Course</th>
              <th>Classroom</th>
              <th>Teacher</th>
            </thead>
            <tbody>
              {scheduleSun.map((sc, i) => {
                return (
                  <tr>
                    {i == 0 ? (
                      <th rowSpan={scheduleSun.length}> Sunday </th>
                    ) : null}
                    <td>Lecture {`${sc.lecture} (${sc.time})`}</td>
                    <td>{sc.coursename}</td>
                    <td>{sc.classname}</td>
                    <td>
                      <a href={`mailto:${sc.teacheremail}`}>{sc.teachername}</a>
                    </td>
                  </tr>
                );
              })}

              {scheduleMon.map((sc, i) => {
                return (
                  <tr>
                    {i == 0 ? (
                      <th rowSpan={scheduleMon.length}> Monday </th>
                    ) : null}
                    <td>Lecture {`${sc.lecture} (${sc.time})`}</td>
                    <td>{sc.coursename}</td>
                    <td>{sc.classname}</td>
                    <td>
                      <a href={`mailto:${sc.teacheremail}`}>{sc.teachername}</a>
                    </td>
                  </tr>
                );
              })}
              {scheduleTue.map((sc, i) => {
                return (
                  <tr>
                    {i == 0 ? (
                      <th rowSpan={scheduleTue.length}>Tuesday</th>
                    ) : null}
                    <td>Lecture {`${sc.lecture} (${sc.time})`}</td>
                    <td>{sc.coursename}</td>
                    <td>{sc.classname}</td>
                    <td>
                      <a href={`mailto:${sc.teacheremail}`}>{sc.teachername}</a>
                    </td>
                  </tr>
                );
              })}
              {scheduleWed.map((sc, i) => {
                return (
                  <tr>
                    {i == 0 ? (
                      <th rowSpan={scheduleWed.length}>Wednesday</th>
                    ) : null}
                    <td>Lecture {`${sc.lecture} (${sc.time})`}</td>
                    <td>{sc.coursename}</td>
                    <td>{sc.classname}</td>
                    <td>
                      <a href={`mailto:${sc.teacheremail}`}>{sc.teachername}</a>
                    </td>
                  </tr>
                );
              })}
              {scheduleThu.map((sc, i) => {
                return (
                  <tr>
                    {i == 0 ? (
                      <th rowSpan={scheduleThu.length}>Thursday</th>
                    ) : null}
                    <td>Lecture {`${sc.lecture} (${sc.time})`}</td>
                    <td>{sc.coursename}</td>
                    <td>{sc.classname}</td>
                    <td>
                      <a href={`mailto:${sc.teacheremail}`}>{sc.teachername}</a>
                    </td>
                  </tr>
                );
              })}

              {/* <tr>
                  <th scope="row">
                    Monday
                  </th>
                  <td scope="row">{scheduleMon.map((s, key) => {
                    return (
                      <tr>Lecture {s.lecture}</tr>
                    )
                  })}</td>
                  <td scope="row">{scheduleMon.map((s, key) => {
                    return (
                      <tr>{s.classname}</tr>
                    )
                  })}</td>
                  <td scope="row">{scheduleMon.map((s, key) => {
                    return (
                      <tr>{s.coursename}</tr>
                    )
                  })}</td>
                  <td scope="row">{scheduleMon.map((s, key) => {
                    return (
                      <tr>{s.time}</tr>
                    )
                  })}</td>
                </tr>
                <tr>
                  <th scope="row">
                    Tuesday
                  </th>
                  <td scope="row">{scheduleTue.map((s, key) => {
                    return (
                      <tr>Lecture {s.lecture}</tr>
                    )
                  })}</td>
                  <td scope="row">{scheduleTue.map((s, key) => {
                    return (
                      <tr>{s.classname}</tr>
                    )
                  })}</td>
                  <td scope="row">{scheduleTue.map((s, key) => {
                    return (
                      <tr>{s.coursename}</tr>
                    )
                  })}</td>
                  <td scope="row">{scheduleTue.map((s, key) => {
                    return (
                      <tr>{s.time}</tr>
                    )
                  })}</td>
                </tr>
                <tr>
                  <th scope="row">
                    Wednesday
                  </th>
                  <td scope="row">{scheduleWed.map((s, key) => {
                    return (
                      <tr>Lecture {s.lecture}</tr>
                    )
                  })}</td>
                  <td scope="row">{scheduleWed.map((s, key) => {
                    return (
                      <tr>{s.classname}</tr>
                    )
                  })}</td>
                  <td scope="row">{scheduleWed.map((s, key) => {
                    return (
                      <tr>{s.coursename}</tr>
                    )
                  })}</td>
                  <td scope="row">{scheduleWed.map((s, key) => {
                    return (
                      <tr>{s.time}</tr>
                    )
                  })}</td>
                </tr>
                <tr>
                  <th scope="row">
                    Thursday
                  </th>
                  <td scope="row">{scheduleThu.map((s, key) => {
                    return (
                      <tr>Lecture {s.lecture}</tr>
                    )
                  })}</td>
                  <td scope="row">{scheduleThu.map((s, key) => {
                    return (
                      <tr>{s.classname}</tr>
                    )
                  })}</td>
                  <td scope="row">{scheduleThu.map((s, key) => {
                    return (
                      <tr>{s.coursename}</tr>
                    )
                  })}</td>
                  <td scope="row">{scheduleThu.map((s, key) => {
                    return (
                      <tr>{s.time}</tr>
                    )
                  })}</td>
                </tr> */}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Schedual;
